import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Web3Provider } from "./web3/Web3Provider";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
	<StrictMode>
		<Web3Provider>
			<App />
		</Web3Provider>
	</StrictMode>,
);
